import { Button, ButtonProps, useColorModeValue } from "@chakra-ui/react";
import React, { forwardRef } from "react";

interface Props extends ButtonProps {
    active?: boolean;
    onClick: () => void;
}

export const ButtonFilterStyle = forwardRef(function ButtonElement(
    { onClick, active = false, children, ...rest }: Props,
    ref: React.Ref<HTMLButtonElement>
) {
    const color = useColorModeValue("gray.300", "gray.600");

    return (
        <Button
            ref={ref}
            variant="unstyled"
            borderWidth="thin"
            borderRadius="md"
            borderColor={active ? "transparent" : color}
            borderStyle="solid"
            color={active ? "gray.600" : ""}
            bgColor={active ? "gray.200" : ""}
            fontWeight="normal"
            fontSize=".9rem"
            size="xs"
            height={8}
            onClick={onClick}
            {...rest}
        >
            {children}
        </Button>
    );
});